import React from 'react';
import { cx, hoc } from '#packages/util';
import constants from '#packages/constants';
import { createStructuredSelector } from '../selectors';
import { boundingStyleSel, layoutStyleSel } from '../selectors';
import { getIsInteractionModeSel } from '../../interactionMode/selectors';

interface LayoutBoundingBoxOwnProps {
  componentUIColor: ValueOf<typeof constants.COMPONENT_UI_COLORS>;
  children: React.ReactNode;
  isMobileOnlyColor: boolean;
}

interface LayoutBoundingBoxStateProps {
  isInInteractionMode: boolean;
  boundingStyle: React.CSSProperties;
  layoutStyle: React.CSSProperties;
}

interface LayoutBoundingBoxProps
  extends LayoutBoundingBoxOwnProps,
    LayoutBoundingBoxStateProps {}

const LayoutBoundingBox: React.FC<LayoutBoundingBoxProps> = (props) => {
  return (
    <div
      style={
        props.isInInteractionMode ? props.layoutStyle : props.boundingStyle
      }
      className={cx('bounding', {
        'components-ui-color-orange':
          props.componentUIColor === constants.COMPONENT_UI_COLORS.ORANGE,
        'components-ui-mobile-only': props.isMobileOnlyColor,
      })}
    >
      {props.children}
    </div>
  );
};

const layoutBoundingBoxPropsSel =
  createStructuredSelector<LayoutBoundingBoxStateProps>({
    isInInteractionMode: getIsInteractionModeSel,
    boundingStyle: boundingStyleSel,
    layoutStyle: layoutStyleSel,
  });

export default hoc.connect(
  hoc.STORES.MOUSE_OPS,
  layoutBoundingBoxPropsSel,
)(LayoutBoundingBox);
